import { QueryClient } from '@tanstack/react-query'
import { QueryKey } from 'src/reactQuery/enums/queryKey.enum'

// Everything a brand profile page reads. A prompt or competitor change moves
// the profile's state, its counts, the dashboard numbers and the prompt lists
// at once, so every mutation of the redesign refreshes the whole set.
const PROFILE_DATA_KEYS = [
  QueryKey.GET_AI_LISTENING_PROFILES,
  QueryKey.GET_AI_LISTENING_PROFILE,
  QueryKey.GET_AI_LISTENING_PROFILE_COMPETITORS,
  QueryKey.GET_AI_LISTENING_PROFILE_DASHBOARD,
  QueryKey.GET_AI_LISTENING_PROFILE_PROMPTS,
  QueryKey.GET_AI_LISTENING_PROFILE_PROMPTS_OVERVIEW,
]

export const invalidateAiListeningProfileData = (queryClient: QueryClient) =>
  Promise.all(
    PROFILE_DATA_KEYS.map((key) =>
      queryClient.invalidateQueries({ queryKey: [key] })
    )
  )

// Prompts are campaigns to the older readers (project widget, campaign
// source selector), so their list is refreshed along with the profile data.
export const invalidateAiListeningPromptData = (
  queryClient: QueryClient,
  promptId?: string
) =>
  Promise.all([
    invalidateAiListeningProfileData(queryClient),
    queryClient.invalidateQueries({
      queryKey: [QueryKey.GET_AI_LISTENING_CAMPAIGNS],
    }),
    promptId
      ? queryClient.invalidateQueries({
          queryKey: [QueryKey.GET_AI_LISTENING_PROMPT_DEEP_DIVE, promptId],
        })
      : undefined,
  ])
